import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=fb511510&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb511510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb511510')) {
      api.createRecord('fb511510', component.options)
    } else {
      api.reload('fb511510', component.options)
    }
    module.hot.accept("./ImageView.vue?vue&type=template&id=fb511510&scoped=true&", function () {
      api.rerender('fb511510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ImageView/ImageView.vue"
export default component.exports